import React, { useMemo, useState } from 'react'
import { Card, Col, Result, Row, Drawer } from 'antd'
import { useSelector } from 'react-redux'
import OneWayListCard from './OneWayListCard'
import RoundTripDomasticCard from './RoundTripDomasticCard'
import RoundTripDomasticReturnCard from './RoundTripDomasticReturnCard'
import RoundTripListInternationalCard from './RoundTripListInternationalCard'
import DomasticSelection from './DomasticSelection'
import { useDispatch } from 'react-redux';
import { applyFilters, setSelectedVenderTypeOnward, setSelectedVenderTypeReturn } from '../../../redux/flight/flightRoundTripFilterSlice'
import Seo from './../../helmet/Helmet'
import FlightsInformation from './FlightsInformation'
import LazyCardLoader from './LazyCardLoader'
import LazyCardDomasticeRoundtrip from './LazyCardDomasticeRoundtrip'

const ResultFlightsTypeVender = ({
    arrivalDataReturn,
    setArrivalDataReturn,
    setDepartureData,
    departureData,
    selectedValueReturn,
    setSelectedValueReturn,
    selectedValue,
    setSelectedValue,
    shouldLoadOnward,
    setShouldLoadOnward,
    shouldLoadReturn,
    setShouldLoadReturn
}) => {

    const [oneWayData, setOneWayData] = useState(null);
    const [open, setOpen] = useState(false);
    const roundCityFlightFilterData = useSelector((state) => state.flightRoundCity.roundCityFlightFilterData);
    const roundCityLoading = useSelector((state) => state.flightRoundCity.filterLoading);
    const flightOneWayloading = useSelector((state) => state.flightOneWay.loading);
    const filterLoading = useSelector((state) => state.flightOneWay.filterLoading);
    const { filteredDataRoundTrip } = useSelector((state) => state.flightFilterRoundTrip);
    const dispatch = useDispatch();

    const onChange = (item, i) => {
        setShouldLoadOnward(true);
        if (selectedValue !== i) {
            setSelectedValue(i);
            setDepartureData(item);
            dispatch(setSelectedVenderTypeOnward(item?.vendor));
            dispatch(setSelectedVenderTypeReturn(item?.vendor));
            dispatch(applyFilters({ roundCityFlightFilterData }));
        }
    };

    const onChangeReturn = (item, i) => {
        setShouldLoadReturn(true);
        setSelectedValueReturn(i);
        setArrivalDataReturn(item);
        dispatch(setSelectedVenderTypeOnward(item?.vendor));
        dispatch(setSelectedVenderTypeReturn(item?.vendor));
        dispatch(applyFilters({ roundCityFlightFilterData }));
    };
    const { filteredData, } = useSelector((state) => state.flightFilter);

    const flightInformation = (item) => {
        setOneWayData(item);
        setOpen(true);
    };
    let returnFlight = JSON?.parse(sessionStorage.getItem('returnFlight')) || 'oneWay';

    const firstFlightVendor = filteredDataRoundTrip?.flights?.[0]?.vendor;
    const filteredReturnFlights = filteredDataRoundTrip?.returnFlights
        ? [...filteredDataRoundTrip.returnFlights].sort((a, b) => {
            if (a.vendor === firstFlightVendor) return -1;
            if (b.vendor === firstFlightVendor) return 1;
            return 0;
        })
        : [];



    const memoizedFlightsInternational = useMemo(() => {
        if (!filteredDataRoundTrip) {
            return { flights: [], returnFlights: [] };
        }

        const onwardFlights = filteredDataRoundTrip.flights || [];
        const allReturnFlights = filteredDataRoundTrip.returnFlights || [];
        const firstOnwardVendor = onwardFlights[0]?.vendor;
        const onwardVendors = [...new Set(onwardFlights.map(f => f.vendor).filter(Boolean))];
        const filteredReturnFlights = allReturnFlights.filter(flight =>
            onwardVendors.includes(flight?.vendor)
        );
        const sortedReturnFlights = [...filteredReturnFlights].sort((a, b) => {
            const aIsFirstVendor = a.vendor === firstOnwardVendor;
            const bIsFirstVendor = b.vendor === firstOnwardVendor;

            if (aIsFirstVendor && !bIsFirstVendor) return -1;
            if (!aIsFirstVendor && bIsFirstVendor) return 1;
            return 0;
        });

        return {
            flights: onwardFlights,
            returnFlights: sortedReturnFlights,
            firstOnwardVendor
        };
    }, [filteredDataRoundTrip]);
    // const memoizedFlightsInternational = useMemo(() => filteredDataRoundTrip || [], [filteredDataRoundTrip]);
    const memoizedFlightsDomastic = useMemo(() => filteredData?.flights || [], [filteredData]);

    return (
        <>
            <div className="flights-accordion">

                {returnFlight === "oneWay" &&
                    <>
                        {memoizedFlightsDomastic?.length === 0 ? (
                            <Card loading={roundCityLoading || flightOneWayloading} className="bg-white rounded p-2">
                                <Result title="Sorry, there are no flights available to this destination. Kindly select a different destination. " />
                            </Card>
                        ) : (
                            <LazyCardLoader
                                data={memoizedFlightsDomastic}
                                CardComponent={OneWayListCard}
                                cardProps={{ oneWayFlightInformation: flightInformation }}
                            />
                        )}

                    </>
                }

                {returnFlight === "roundTrip" &&
                    <>
                        {/*Return Component */}
                        {filteredDataRoundTrip?.flights?.length === 0 && filteredDataRoundTrip?.results?.returnFlights?.length === 0 ?
                            <Card loading={roundCityLoading || flightOneWayloading || filterLoading} className="p-2">
                                <Result title="Sorry, there are no flights available to this destination. Kindly select a different destination. " />
                            </Card> :
                            <>
                                {filteredDataRoundTrip?.checkFlightType === "INTERNATIONAL" &&
                                    <>
                                        <div className="flights-list">
                                            <LazyCardLoader
                                                data={memoizedFlightsInternational?.flights}
                                                CardComponent={RoundTripListInternationalCard}
                                                cardProps={{
                                                    flightInformation: flightInformation
                                                }}
                                            />
                                        </div>
                                    </>
                                }

                                {filteredDataRoundTrip?.checkFlightType === "DOMESTIC" &&
                                    <Row gutter={20} className='mb-4 mb-md-0'>
                                        <Col md={24} xs={24} className='mobile_sticky'>
                                            <DomasticSelection
                                                departureData={departureData}
                                                setArrivalDataReturn={setArrivalDataReturn}
                                                arrivalDataReturn={arrivalDataReturn}
                                                filteredReturnFlights={filteredReturnFlights}
                                                memoizedFlightsInternational={memoizedFlightsInternational}
                                            />
                                        </Col>

                                        <Col md={12} xs={12} className='p-0 px-md-2 mobile_return_flight'>
                                            <div className='scroll_return pb-5 pb-md-0'>
                                                <LazyCardDomasticeRoundtrip
                                                    data={memoizedFlightsInternational?.flights}
                                                    filterKey={shouldLoadOnward}
                                                    CardComponent={RoundTripDomasticCard}
                                                    cardProps={{
                                                        selectedValue,
                                                        onChange: (item, i) => onChange(item, i),
                                                        isSelected: (i) => selectedValue === i,
                                                        flightInformation,
                                                    }}
                                                />

                                            </div>
                                        </Col>

                                        <Col md={12} xs={12} className='p-0 px-md-2 mobile_return_flight'>
                                            <div className='scroll_return pb-5 pb-md-0'>
                                                <LazyCardDomasticeRoundtrip
                                                    data={memoizedFlightsInternational?.returnFlights}
                                                    filterKey={shouldLoadReturn}
                                                    CardComponent={RoundTripDomasticReturnCard}
                                                    cardProps={{
                                                        selectedValueReturn,
                                                        onChangeReturn: (item, i) => onChangeReturn(item, i),
                                                        isSelected: (i) => selectedValueReturn === i,
                                                        flightInformation,
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                    </Row >
                                }

                            </>
                        }
                    </>
                }
            </div >

            {/* flights Information  */}
            <Drawer title="Information" width={680} onClose={() => setOpen(false)} open={open} >
                <FlightsInformation oneWayData={oneWayData} />
            </Drawer>

        </>
    )
}

export default ResultFlightsTypeVender
